import React, { Suspense } from 'react';

import { ConnectedRouter } from 'connected-react-router';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
/* import { useSyncExternalStore } from 'use-sync-external-store/shim';

Object.defineProperty(React, 'useSyncExternalStore', {
    value: useSyncExternalStore,
    configurable: true,
    writable: true,
}); */

import App from './App';
import './i18n';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import './index.css';
import * as serviceWorker from './serviceWorker';
import configureStore, { history } from './store';
import { initAllThirdParty } from './thirdParty';

const store = configureStore();

initAllThirdParty();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Suspense fallback={null}>
                <App />
            </Suspense>
        </ConnectedRouter>
    </Provider>,
);

serviceWorker.unregister();
